import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Bearden Behavioral Health theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const BBHOFTN_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/bbhoftn/logo.png",
        alt: "Bearden Behavioral Health Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 34,
  state: "TN",
  departmentIds: [155, 260, 261],
};
